import { render, staticRenderFns } from "./_EventsPanel.vue?vue&type=template&id=5372b385&"
import script from "./_EventsPanel.vue?vue&type=script&lang=ts&"
export * from "./_EventsPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/packages/axiom-design-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5372b385')) {
      api.createRecord('5372b385', component.options)
    } else {
      api.reload('5372b385', component.options)
    }
    module.hot.accept("./_EventsPanel.vue?vue&type=template&id=5372b385&", function () {
      api.rerender('5372b385', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/04-web-components/powerbar/components/PowerbarNav/_EventsPanel.vue"
export default component.exports